export enum FormType {
  INSERT = "INSERT",
  UPDATE =  "UPDATE",
  SHOW = "SHOW"
}
